module.exports = __webpack_public_path__ + "static/media/mobile_archero2_page_area04_img_cn@2x.3226c677.png";